import React from 'react';


function Cursos() {
  return (
    <div className="cursos-wrapper">
      <div className="cursos-imagens-container">
        <img src="/mini-curso-vini.png" alt="Mini Curso 1" className="curso-img" />
        <img src="/mini-curso-vini-2.png" alt="Mini Curso 2" className="curso-img" />
      </div>

      <div className="cta-container">
        
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSc6rUM4btnhjcnIzqm_G4yFcRJuOAVbgvda-F_eaN1IPngKtg/viewform"
          target="_blank"
          rel="noopener noreferrer"
          className="cta-button"
        >
          Fazer Inscrição 📝
        </a>
      </div>
    </div>
  );
}

export default Cursos;
